import type { ReactNode } from "react";

interface PhoneMockupProps {
  children: ReactNode;
  className?: string;
}

/**
 * Mockup realista de smartphone para exibir vídeos/interface PlayMenu.
 */
export default function PhoneMockup({ children, className = "" }: PhoneMockupProps) {
  return (
    <div className={`relative ${className}`}>
      {/* Moldura do aparelho */}
      <div className="relative rounded-[2.75rem] bg-foreground-800/80 p-[3px]">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-foreground-950 ring-1 ring-foreground-700/60">
          {/* Dynamic island */}
          <div className="pointer-events-none absolute left-1/2 top-2.5 z-20 h-6 w-24 -translate-x-1/2 rounded-full bg-foreground-950" />

          <div className="relative aspect-[9/19] w-full">{children}</div>
        </div>
      </div>
    </div>
  );
}